"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var PrintJob = require('../../PrintJob');

var _require = require('../../estimatePrintingCost'),
    estimatePrintJobPrintingCost = _require.estimatePrintJobPrintingCost;

function EstimatedPricing(_ref) {
  var printJob = _ref.printJob,
      options = _ref.options,
      printer = _ref.printer,
      variant = _ref.variant;
  var priceEstimation = estimatePrintJobPrintingCost(printJob, printer, variant, options);
  var lineItems = priceEstimation.breakdown;
  var total_price = priceEstimation.total;
  var list = lineItems.map(function (fields) {
    var sum = fields.slice(1).map(function (f) {
      return f.value;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
    var str;

    if (fields[1].value == null) {
      throw new Error('Price Estimation field was not defined');
    }

    if (fields.length === 3) {
      str = [fields[0].value, ': ', fields[1].value.toFixed(2), ' + ', fields[2].value.toFixed(2), ' = ', sum.toFixed(2)];
    } else if (fields.length === 4) {
      str = [fields[0].value, ': ', fields[1].value.toFixed(2), ' + ', fields[2].value.toFixed(2), ' + ', fields[3].value.toFixed(2), ' = ', sum.toFixed(2)];
    } else {
      throw new Error('Price Estimation field length was unexpected');
    }

    return /*#__PURE__*/React.createElement("span", {
      key: str.join('')
    }, str.join(''), /*#__PURE__*/React.createElement("br", null));
  });
  return /*#__PURE__*/React.createElement("div", null, list, /*#__PURE__*/React.createElement("span", null, "TOTAL PRICE: ", total_price.toFixed(2)));
}

EstimatedPricing.propTypes = {
  options: PropTypes.any,
  printer: PropTypes.oneOf(['pistachioPress', 'printingPlus']),
  printJob: PropTypes.instanceOf(PrintJob).isRequired,
  variant: PropTypes.oneOf(['SampleSets', 'TestPrints', 'FullOrders'])
};
module.exports = EstimatedPricing;